<template>
  <footer id="footer" aria-label="Footer">
    <!-- Footer logo -->
    <div class="flex bg-[--footer-top-bg-color] border-y border-[--color-footer-divider]">
      <div class="mx-auto w-full max-w-screen-2xl px-5 py-4 md:px-12">
        <div class="flex-none">
          <VcImage :src="secondaryLogoUrl" :alt="$context.storeName" class="h-6" lazy />
        </div>
      </div>
    </div>

    <!-- Top footer -->
    <div v-if="!compact" class="flex bg-[--footer-top-bg-color] border-y border-[--color-footer-divider]">
      <div class="mx-auto w-full max-w-screen-2xl px-5 py-4 md:px-12">
        <div class="grid sm:grow sm:grid-cols-2 sm:gap-12 md:grid-cols-3 lg:grid-cols-4 xl:gap-19 2xl:grid-cols-5">
          <template v-if="whiteLabelingFooterLinks?.length">
            <FooterLinks
              v-for="(footerLink, index) in whiteLabelingFooterLinks"
              :key="index"
              :links-block="footerLink"
            />
          </template>

          <template v-else>
            <FooterLinks v-for="footerLink in footerLinks" :key="footerLink.id" :links-block="footerLink" />
          </template>

          <InnoContactInfo />

          <InnoSocialMedia />
        </div>
      </div>
    </div>

    <!-- Bottom footer -->
    <div class="flex bg-[--footer-bottom-bg-color]">
      <div class="mx-auto w-full max-w-screen-2xl">
        <div
          class="flex flex-col items-center justify-between gap-1 p-4 text-center text-sm text-[--footer-bottom-text-color] md:flex-row md:px-6 md:py-5 print:flex-row print:bg-additional-50 print:px-0 print:text-additional-950"
        >
          <span>
            <span class="md:ml-4 mr-1">&copy;{{ new Date().getFullYear() }}</span>
            <span class="mr-2"
              ><strong>{{ $t("shared.layout.footer.company_name") }}</strong
              >.</span
            >
            <span class="text-xxs">{{ $t("shared.layout.footer.all_rights_reserved") }}</span>
          </span>

          <span class="text-[--color-footer-bottom-version-text] text-xxs"
            >{{ $t("shared.layout.footer.version") }} {{ version }}</span
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useNavigations, useWhiteLabeling } from "@/core/composables";
import pkg from "../../../../../../package.json";
import FooterLinks from "../_internal/footer-links.vue";
import InnoSocialMedia from "./inno-social-media.vue";
import InnoContactInfo from "./inno-contact-info.vue";

interface IProps {
  compact?: boolean;
}

const props = defineProps<IProps>();

const { secondaryLogoUrl, footerLinks: whiteLabelingFooterLinks } = useWhiteLabeling();
const { footerLinks, fetchFooterLinks } = useNavigations();
const { version } = pkg;

onMounted(() => {
  if (!props.compact) {
    void fetchFooterLinks();
  }
});
</script>
